import { Component, OnInit, Inject } from '@angular/core';
import { ISelectOptions } from '../../../../interfaces/abstract';
import { ICoverCropViewModel } from '../../interfaces';
import { CoverCropFields } from '../../calculatorSettingsForm';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedUpdateService } from '../../../shared/dialogs/update.service';

@Component({
	moduleId: module.id,
	selector: 'cover-crop',
	templateUrl: 'cover-crop.html'
})

export class CoverCropComponent implements OnInit {

	public standOptions: ISelectOptions[] = [
		{ key: 0, value: 'No Cover Crop' },
		{ key: 30, value: 'Poor Crop' },
		{ key: 70, value: 'Good Crop' },
		{ key: 120, value: 'Great Crop' },
	];

	public incorporationMethodOptions: ISelectOptions[] = [
		{ key: 0, value: 'N/A' },
		{ key: 0.7, value: 'Disc In' },
		{ key: 0.5, value: 'Mow Only' },
	];

	public get f(): { [key in CoverCropFields]: AbstractControl } {
		return this.form.controls as { [key in CoverCropFields]: AbstractControl };
	}

	public form: FormGroup;
	private _control: AbstractControl;

	private _initialValues: ICoverCropViewModel;

	constructor(
		private _dialogRef: MatDialogRef<CoverCropComponent>,
		@Inject(MAT_DIALOG_DATA) private _data: { form: FormGroup, control: AbstractControl },
		private _sharedUpdateService: SharedUpdateService,
	) {
	}

	ngOnInit(): void {
		this.form = this._data.form;
		this._control = this._data.control;
		this._initialValues = this.form.value;
	}

	public calculate(e: MouseEvent): void {
		let result: number;

		result = this.f.LegumeCoverCropStand.value * this.f.IncorporationMethod.value;
		this._control.setValue(result);
		this._closeDialog();
	}

	public cancel(e: MouseEvent): void {
		this.form.reset(this._initialValues);
		this._closeDialog();
	}

	private _closeDialog() {
		this._sharedUpdateService.cancel();
		this._dialogRef.close();
	}
}
